import {ISceneManager, HashedMaterialNodeWithColorOutput} from "@cm/template-nodes"
import {hashObject, TypedImageData} from "@cm/utils"
import {AsyncCacheMap} from "@common/helpers/async-cache-map/async-cache-map"
import {BakeTextureService} from "@template-editor/services/bake-texture.service"
import {from, Observable} from "rxjs"

export class BakeTextureCache {
    protected cache: AsyncCacheMap<string, TypedImageData, [HashedMaterialNodeWithColorOutput, number, number, number, number]>

    constructor(
        private bakeTextureService: BakeTextureService,
        private sceneManager: ISceneManager,
    ) {
        this.cache = new AsyncCacheMap((key, [textureNode, widthUV, heightUV, widthPx, heightPx]) =>
            from(this.bakeTextureService.bakeTexture(textureNode, widthUV, heightUV, widthPx, heightPx, this.sceneManager.getResolver())),
        )
    }

    get(textureNode: HashedMaterialNodeWithColorOutput, widthUV: number, heightUV: number, widthPx: number, heightPx: number): Observable<TypedImageData> {
        return this.cache.get(hashObject({textureNodeContentHash: textureNode.contentHash, widthUV, heightUV, heightPx, widthPx}), [
            textureNode,
            widthUV,
            heightUV,
            widthPx,
            heightPx,
        ])
    }
}
